import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function HistoricTabs({ ilk }) {
  const [activeDisplayOption, setActiveDisplayOption] = useState('debt');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(
    () => [
      { key: 'debt', value: 'Total Debt' },
      { key: 'activity', value: 'Activity' }
    ],
    []
  );
  let url = `/groups/spark/ilks/${ilk}/historic/`;
  if (activeDisplayOption == 'activity') {
    url = `/groups/spark/ilks/${ilk}/historic-volume/`;
  }
  const [data, error] = useApi({
    url: url,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <HistoricGraphs
          data={data}
          type={activeDisplayOption}
          timeFilter={timeFilter}
          chartDaysAgo={chartDaysAgo}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
